export type TimeOfDay = {
    hours?: number
    minutes?: number
    seconds?: number
}

export type Transition = {
    time: TimeOfDay
    value: number
}

export type DailySchedule = {
    initial: number
    transitions: Transition[]
}

export type DateOnly = {
    year: number
    month: number
    day: number
}

export type DaysOfWeek = {
    days: DayOfWeek[]
}

export type DateRange = {
    start: DateOnly
    end: DateOnly
}

export type DayOfWeek =
    | "DAY_OF_WEEK_UNSPECIFIED"
    | "MONDAY"
    | "TUESDAY"
    | "WEDNESDAY"
    | "THURSDAY"
    | "FRIDAY"
    | "SATURDAY"
    | "SUNDAY"


export type Condition = {
    days?: DaysOfWeek
    dateRange?: DateRange
}


export type OverrideSchedule = {
    condition: Condition
    schedule: DailySchedule
}

export type Schedule = {
    schedule: DailySchedule
    overrides: OverrideSchedule[]
    timezone: string
}

export enum ConfigProto {
    Type = "type.googleapis.com/auto_arm.Config"
}

export type Config = {
    "@type": ConfigProto
    enabled?: boolean
    schedule?: Schedule
}

export const createConfig = (autoArm?: Schedule, enabled?: boolean): Config => {
    return {
        "@type": ConfigProto.Type,
        enabled: enabled,
        schedule: autoArm,
    }
}

export const newSchedule = (): Schedule => {
    return {
        schedule: {
            initial: INITIAL_STATE_ARMED,
            transitions: [],
        },
        overrides: [],
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
}

export const newConfig = (): Config => createConfig(newSchedule(), false)

export const isDateRange = (condition: Condition): condition is { dateRange: DateRange } => {
    return condition.dateRange !== undefined
}

export const isDaysOfWeek = (condition: Condition): condition is { days: DaysOfWeek } => {
    return condition.days !== undefined
}

export const INITIAL_STATE_ARMED = 1
